import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button, Alert } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { Lock, Mail, Eye, EyeOff } from "lucide-react";
import { APICALL } from "../api/api";
import { auth, encryptLocalStorageData } from "../api/Utility";
import logo from "../../src/assets/images/logo-ai.png";
import logoblack from "../../src/assets/images/logo-ai-black.png";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [validated, setValidated] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);
  useEffect(() => {
    if (auth()) {
      navigate("/");
    }
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    setValidated(true);
    if (form.checkValidity()) {
      const params = {
        email: email,
        password: password,
      };
      setErr(null);
      try {
        setLoading(true);
        const res = await APICALL("/user/adminLogin", "post", params);
        if (res?.status === 200) {
          setShowAlert(true);
          const dataParam = {
            token: res?.token,
            fullName: res?.data?.firstName + " " + res?.data?.lastName,
            email: res?.data?.email,
            id: res?.data?._id,
            role: res?.data?.role,
            status: res?.data?.status,
          };
          encryptLocalStorageData("web-secret", dataParam, "DoNotTryToAccess");
          setTimeout(() => {
            navigate("/");
          }, 1000);
        } else {
          setErr(res?.message || "Login failed!");
        }
      } catch (err) {
        setErr(err.message || "Something went wrong.");
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <>
      <section className="login_page">
        <Container>
          <Row className="justify-content-center">
            <Col md={6}>
              <div className="login-card">
                <div className="text-center mb-4">
                  <div class="website_logo mb-5">
                    <img className="white_logo" src={logo} alt="" />

                    <img className="black_logo" src={logoblack} alt="" />
                  </div>
                  <h1 className="login-title">Welcome</h1>
                  <p className="text-white">Sign in to access AI services</p>
                </div>

                {/* {showAlert && (
                  <Alert variant="success" className="mb-4">
                    Login successful! Redirecting...
                  </Alert>
                )} */}

                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label htmlFor="email">
                      <Mail size={16} className="me-2" />
                      Email Address
                    </Form.Label>
                    <Form.Control
                      type="email"
                      id="email"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      className="form-control-dark"
                    />
                    <Form.Control.Feedback type="invalid">
                      Please provide a valid email address.
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="mb-4 position-relative">
                    <Form.Label htmlFor="password">
                      <Lock size={16} className="me-2" />
                      Password
                    </Form.Label>

                    <div className="position-relative">
                      <Form.Control
                        type={showPassword ? "text" : "password"}
                        id="password"
                        placeholder="Enter your password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        minLength={4}
                        className="form-control-dark pe-5"
                      />
                      <Button
                        variant="link"
                        className="position-absolute top-50 end-0 translate-middle-y pe-3 text-light border-0"
                        onClick={() => setShowPassword(!showPassword)}
                        type="button"
                      >
                        {showPassword ? (
                          <EyeOff size={16} />
                        ) : (
                          <Eye size={16} />
                        )}
                      </Button>
                    </div>
                    <Form.Control.Feedback type="invalid">
                      Password must be at least 6 characters long.
                    </Form.Control.Feedback>
                  </Form.Group>

                  <div className="text-end mb-4">
                    {/* <Form.Check
                      type="checkbox"
                      id="remember"
                      label="Remember me"
                      className="text-light"
                    /> */}
                    <Link
                      to="/forgot-password"
                      className="text-decoration-none p-0"
                      style={{ color: "#667eea" }}
                    >
                      Forgot password?
                    </Link>
                  </div>

                  {err && (
                    <p className="text-danger">
                      <strong> {err}</strong>
                    </p>
                  )}

                  <Button
                    type="submit"
                    className="btn-gradient w-100 mb-3 d-flex align-items-center justify-content-center"
                    size="lg"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Loading...
                      </>
                    ) : (
                      "Sign In"
                    )}
                  </Button>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Login;
